module.exports = __webpack_public_path__ + "static/dunning-retention-screenshot2-6620fb8795e48ece5da567bbe296e56e.png";